import React from 'react';
import Box from '@Atoms/Box';
import Tooltip from '@Atoms/Tooltip';
import { useTheme } from '@mui/material/styles';

interface HierarchyHeaderProps {
  label: string;
  leftMargin?: number;
  tooltipTitle?: string;
  bgColor?: string;
  secondColumnLabel?: string;
  showScoreLegend?: boolean;
}

/**
 * Helper component to display colored circles with score range legend
 */
const ScoreLegend: React.FC = () => {
  const theme = useTheme();

  const legendItems = [
    { color: theme.palette.error.main, label: 'score <= 49%' },
    { color: theme.palette.success.main, label: 'score <= 79%' },
    { color: theme.palette.primary.main, label: 'score > 79%' },
  ];

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
      <span>Results</span>
    </Box>
  );
};

const HierarchyHeader: React.FC<HierarchyHeaderProps> = ({
  label,
  leftMargin = 0,
  tooltipTitle,
  bgColor = 'grey.50',
  secondColumnLabel = '# of Students',
  showScoreLegend = false,
}) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: 'repeat(12, 1fr)',
      gap: 2,
      px: 3,
      py: 1,
      alignItems: 'center',
      bgcolor: bgColor,
      borderTop: 1,
      borderColor: 'divider',
    }}
  >
    <Box
      sx={{
        gridColumn: 'span 5',
        fontSize: '0.75rem',
        fontWeight: 600,
        color: 'text.secondary',
        textTransform: 'uppercase',
        letterSpacing: 1,
        ml: leftMargin,
      }}
    >
      {label}
    </Box>
    <Box
      sx={{
        gridColumn: 'span 2',
        textAlign: 'center',
        fontSize: '0.75rem',
        fontWeight: 600,
        color: 'text.secondary',
        textTransform: 'uppercase',
        letterSpacing: 1,
      }}
    >
      {secondColumnLabel}
    </Box>
    <Box sx={{ gridColumn: 'span 5' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          fontSize: '0.75rem',
          fontWeight: 600,
          color: 'text.secondary',
          textTransform: 'uppercase',
          letterSpacing: 1,
        }}
      >
        {tooltipTitle ? (
          <Tooltip title={tooltipTitle} placement="top">
            <span>{showScoreLegend ? <ScoreLegend /> : <span>Results</span>}</span>
          </Tooltip>
        ) : showScoreLegend ? (
          <ScoreLegend />
        ) : (
          <span>Results</span>
        )}
      </Box>
    </Box>
  </Box>
);

export default HierarchyHeader;
